var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 8,
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1.5V3H13.5V4.5H12.75V6H1.5V1.5H12.75ZM13.125 0H1.125C0.492188 0 0 0.515625 0 1.125V6.375C0 7.00781 0.492188 7.5 1.125 7.5H13.125C13.7344 7.5 14.25 7.00781 14.25 6.375V6H14.4375C14.7422 6 15 5.76562 15 5.4375V2.0625C15 1.75781 14.7422 1.5 14.4375 1.5H14.25V1.125C14.25 0.515625 13.7344 0 13.125 0ZM12 2.25H2.25V5.25H12V2.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.c2e8745dd9d7be6dbf15d2f84b597dce.svg";
export { ForwardRef as ReactComponent };